import React from 'react';

import Dialog from 'material-ui/Dialog';

const Error404 = () =>  (
    <Dialog
        title="Oh snap!"
        modal={true}
        open={true}
    >
        <p>Page not found...</p>
        <p>Click 'back' in your browser.</p>
    </Dialog>
);

export default Error404;
